import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import About from "../../icons/About";
import Balance from "../../icons/Balance";
import Currency from "../../icons/Currency";
import Event from "../../icons/Event";
import FAQ from "../../icons/FAQ";
import Language from "../../icons/Language";
import PersonalInfo from "../../icons/PersonalInfo";

import { CurrencyChanger, LangChanger } from "../../../../components";
import MenuListItem from "./components/MenuListItem";
import styles from "./style.module.scss";

function MenuList() {
  const [showCurrencyChanger, setShowCurrencyChanger] = useState(false);
  const [showLangChanger, setShowLangChanger] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const menuItems = [
    {
      title: t("menu.personal.balance"),
      icon: <Balance />,
      itemOnClick: () => {
        navigate("/balance");
      },
    },
    {
      title: t("menu.personal.personalInfo"),
      icon: <PersonalInfo />,
      itemOnClick: () => {
        navigate("/profile");
      },
    },
    {
      title: t("menu.personal.agentEvent"),
      icon: <Event />,
      itemOnClick: () => {
        navigate("/personal/event");
      },
    },
    {
      title: t("personal.help.faqs"),
      icon: <FAQ />,
      itemOnClick: () => {
        navigate("/personal/help?tab=commonIssues");
      },
    },
    {
      title: t("personal.help.about"),
      icon: <About />,
      itemOnClick: () => {
        navigate("/personal/help?tab=about");
      },
      hasBottomBorder: true,
    },
    {
      title: t("mobile.personal.menu.currency"),
      icon: <Currency />,
      itemOnClick: () => {
        setShowCurrencyChanger(true);
      },
    },
    {
      title: t("mobile.personal.menu.lang"),
      icon: <Language />,
      itemOnClick: () => {
        setShowLangChanger(true);
      },
    },
  ];
  return (
    <div className={styles.menuList}>
      {menuItems?.map((item, index) => {
        return <MenuListItem {...item} index={"personalMenu" + index} />;
      })}
      <CurrencyChanger
        visible={showCurrencyChanger}
        onClose={() => {
          setShowCurrencyChanger(false);
        }}
      />
      <LangChanger
        visible={showLangChanger}
        onClose={() => {
          setShowLangChanger(false);
        }}
      />
    </div>
  );
}

export default MenuList;
